import {useCallback} from 'react';
import {useNavigate} from 'react-router';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {
  removeMergeSuggestionFromQueue,
  selectNextMergeSuggestionInQueue,
} from '../mergeSuggestionQueueSlice';
import {
  useGetMergeSuggestionBySourceIdAndTargetIdQuery,
  useMarkMergeSuggestionAsProcessedMutation,
} from '../mergeSuggestionsApi';

export const useCloseMergeSuggestionAndContinue = (
  targetId: string | undefined,
  sourceId: string | undefined,
) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {data: currentMergeSuggestion} =
    useGetMergeSuggestionBySourceIdAndTargetIdQuery(
      {
        targetId: targetId ?? '',
        sourceId: sourceId ?? '',
      },
      {
        skip: !targetId || !sourceId,
      },
    );

  const nextMergeSuggestionInQueue = useAppSelector(
    selectNextMergeSuggestionInQueue,
  );
  const [markMergeSuggestionAsProcessedMutation] =
    useMarkMergeSuggestionAsProcessedMutation();

  const closeSuggestionAndContinue = useCallback(() => {
    if (currentMergeSuggestion) {
      markMergeSuggestionAsProcessedMutation(currentMergeSuggestion.id);
    }

    if (nextMergeSuggestionInQueue) {
      dispatch(removeMergeSuggestionFromQueue(nextMergeSuggestionInQueue));
      navigate(nextMergeSuggestionInQueue.link);
    } else {
      navigate('/mergeOverview');
    }
  }, [
    currentMergeSuggestion,
    dispatch,
    markMergeSuggestionAsProcessedMutation,
    navigate,
    nextMergeSuggestionInQueue,
  ]);

  return {closeSuggestionAndContinue, currentMergeSuggestion};
};
